import React from "react";
import styles from "./styles.m.css";

const ElectionFooter = () => {
  return (
    <div className={styles["election-footer"]}>
      <p className={styles["election-footer-copyright"]}>© vikatan 2026. All Rights Reserved</p>
    </div>
  );
};

export default ElectionFooter;
